import { styled } from '../styled';

// Vertical-only padding. Horizontal alignment comes from the parent
// container (DialogBody supplies 28px sides at the dialog level). The
// borderTop runs flush as a section divider.
const Wrap = styled('section')({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  padding: '20px 0',
  borderTop: '1px solid var(--qhs-border)',
  '&:first-of-type': { borderTop: 'none' },
});

const Title = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  fontFamily: 'var(--qhs-font-head)',
  fontSize: 13,
  fontWeight: 700,
  color: 'var(--qhs-text-1)',
  letterSpacing: 0.3,
  textTransform: 'uppercase',
});

const NumTag = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 22,
  height: 22,
  borderRadius: 999,
  background: 'rgba(46, 72, 211, 0.10)',
  color: 'var(--qhs-brand)',
  fontSize: 11,
  fontWeight: 700,
  fontFamily: "'Source Code Pro', 'JetBrains Mono', monospace",
  fontVariantNumeric: 'tabular-nums',
});

const Body = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

const ConfigureSection = ({ num, title, children }) => (
  <Wrap>
    <Title>
      <NumTag>{num}</NumTag>
      {title}
    </Title>
    <Body>{children}</Body>
  </Wrap>
);

export default ConfigureSection;
